import { render, staticRenderFns } from "./RespondToLeaveJourneyMap.vue?vue&type=template&id=78b6a228&scoped=true"
import script from "./RespondToLeaveJourneyMap.vue?vue&type=script&lang=ts"
export * from "./RespondToLeaveJourneyMap.vue?vue&type=script&lang=ts"
import style0 from "./RespondToLeaveJourneyMap.vue?vue&type=style&index=0&id=78b6a228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6a228",
  null
  
)

export default component.exports